/**
 * Accessibility for tags.
 * @type {{attach: Drupal.behaviors.links.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const accessibleTags_once = once('accessible-tags-once', '.field--name-field-group-content-tags', context);

    $(accessibleTags_once).each(function () {
      let $links = $(this).find('.field--item a');

      $links.each(function() {
        $(this).attr('title', Drupal.t('Opens a new page with a list of all links to this topic'));
        $(this).append('<span class="visually-hidden">' + Drupal.t('Opens a new page with a list of all links to this topic') + '</span>')
      });
    });
  },
}
